import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import axios from 'axios';
import swal from 'sweetalert';
import { Table, Checkbox, Popover } from 'antd';

import { getCookie } from '../common_component/cookie.js';
import { useAuthData } from "./auth-provider.js"
import PageError from "../common_component/PageError.js";
import PageLoader from "../common_component/PageLoader.js";

function Roles() {
    const [state, setstate] = useState(2);
    const history = useHistory()

    const [navtype, setnavtype] = useState("General");
    const [newAccess, setNewAccess] = useState({ access: [] });

    const [Role_name, setRole_name] = useState("");
    const [Description, setDescription] = useState("");

    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

    var page_name = "roles";

    const { user, read, write, visibility, organization_id, user_role } = useAuthData(page_name)

    const basePagesMapping = {

        "item-list": ["add-item", "item-images", "edit-item", "item-price-information", "item-stock-information", "edit-item-stock-information"],

        "customer-list": ["add-customer", "edit-customer-details", "customer-address-details", "view-customer-details"],

        "customer-order-list": ["create-customer-order", "view-customer-order", "edit-customer-order"],
        "customer-invoice-list": ["create-customer-invoice", "view-customer-invoice", "edit-customer-invoice"],
        "customer-warehouse-processing-list": ["customer-warehouse-processing"],
        "customer-delivery-challan-list": ["create-customer-delivery-challan"],
        "customer-recurring-invoice-list": ["create-customer-recurring-invoice", "view-customer-recurring-invoice"],
        "payment-received-list": ["new-payment-received", "edit-payment-received"],
        "credit-note-list": ["create-credit-note", "edit-credit-note"],
        "sales-return-list": ["create-sales-return", "view-sales-return-details", "edit-sales-return"],

        "list-vendor": ["add-vendor", "update-vendor", "vendor-address-details"],
        "list-manufacturer": ["add-manufacturer", "update-manufacturer", "manufacturer-address-details"],
        "purchase-order-list": ["create-purchase-order", "edit-purchase-order", "view-purchase-order", "purchase-order-approval-email"],
        "goods-received-list": ["create-goods-receive", "edit-goods-receive", "view-goods-receive"],
        "bill-list": ["create-bill", "edit-bill", "view-bill"],
        "payment-list": ["make-payment", "edit-payment-details"],

        "expense-list": ["add-expense", "edit-expense-details"],
        "reports": ["all-report"],

        "roles": ["update-roles"],
        "profiles": ["update-profile"],
    }

    useEffect(() => {
        async function get_default_role() {
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-default-role`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id, "service": process.env.REACT_APP_module_name }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.length > 0) {
                setNewAccess(JSON.parse(body[0].user_role_access));

                setstate(1)
            }
            else {
                setstate(0);
            }
        }

        if (read || write) {
            (user.email && visibility) && get_default_role();
        }
    }, [user, visibility, read, write])

    const updateNewAccess = (val, path, type) => {
        // console.log(val, path, type);

        let t = JSON.parse(JSON.stringify(newAccess))

        let targetObject = t.access
        for (const k of path) {
            if (targetObject.hasOwnProperty("inside_components")) {
                targetObject = targetObject.inside_components
            }
            targetObject = targetObject.find(obj => (obj.key === k) || (Object.keys(obj)[0] === k))
        }
        // console.log(targetObject);

        if (type === "visibility") {
            if (targetObject.hasOwnProperty("key")) {
                targetObject.visibility = +val
                targetObject.inside_components = JSON.parse(JSON.stringify(targetObject.inside_components).replaceAll((+(!val)).toString(), +val))  //turn all permissions of child objects to on or off
            } else {
                targetObject[Object.keys(targetObject)[0]] = +val
                targetObject.read = +val
                targetObject.write = +val
            }
        }
        else if (type === "read") {
            targetObject.read = +val
            if (val) {
                targetObject[Object.keys(targetObject)[0]] = +val
            }
            if (!val) {
                targetObject.write = +val
            }
        }
        else if (type === "write") {
            targetObject.write = +val
            if (val) {
                targetObject[Object.keys(targetObject)[0]] = +val
                targetObject.read = +val
            }
        }

        setNewAccess(t)
    }

    const addRole = () => {
        if (Role_name.trim() === "") {
            swal("Warning!", "Role name cannot be empty", "warning");
            return false;
        }

        var object = {};
        object.service = process.env.REACT_APP_module_name;
        object.user_role = Role_name;
        object.role_description = Description;
        object.user_role_access = newAccess;
        object.user_role_actions = [];

        object.page_name = page_name
        object.organization_id = organization_id;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }

        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-role-details`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", "Role details added successfully!", "success").then(() => { history.push("/roles") });
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error);
                swal("Oops!", error, "error");
            });
    }

    function getElementByXpath(path) {
        return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
    }

    function scrollToTop() {
        getElementByXpath("/html/body/div/div/div[2]/div[2]").scrollTo({ top: 0, behavior: 'smooth' });
    }

    function scrollToBottom() {
        const elem = getElementByXpath("/html/body/div/div/div[2]/div[2]");
        elem.scrollTo({ top: elem.scrollHeight, behavior: 'smooth' })
    }

    function formatText(text) {
        return text
            .split(/[-_]/) // Split by either '-' or '_'
            .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            .join(' '); // Join back with spaces
    }

    function recursiveTree(obj, path, isParentEnabled) {
        if (obj.hasOwnProperty("key")) {
            return {
                key: obj.key,
                page: obj.key,
                path: [...path, obj.key],
                isParentEnabled: isParentEnabled,
                visibility: obj.visibility,
                read: null,
                write: null,
                children: obj.inside_components.map(x => recursiveTree(x, [...path, obj.key], obj.visibility))
            }
        } else {
            return {
                key: Object.keys(obj)[0],
                page: Object.keys(obj)[0],
                path: [...path, Object.keys(obj)[0]],
                isParentEnabled: isParentEnabled,
                visibility: obj[Object.keys(obj)[0]],
                read: obj.read,
                write: obj.write
            }
        }
    }

    const columns = [
        {
            title: 'Page',
            dataIndex: 'page',
            render: (page, record) => {
                if (record.children && record.children.length > 0) {
                    return <strong>{formatText(page)}</strong>; // Bold for parent nodes
                }

                let showInfo = Object.keys(basePagesMapping).includes(page)
                return <div className="d-flex align-items-center">
                    <span>{formatText(page)}</span>
                    {
                        !record.visibility && showInfo &&
                        <Popover
                            title="Alert! The following pages are dependent on this page's access: "
                            content={
                                basePagesMapping[page].map(x =>
                                    <><span>{formatText(x)}</span><br /></>
                                )
                            }
                            trigger="click"
                        ><i className="bi bi-exclamation-circle-fill text-danger fs-1 ms-5"></i>
                        </Popover>
                    }
                </div>
            },
        },
        {
            title: 'Visibility',
            dataIndex: 'visibility',
            render: (visibility, record) => {
                return <Checkbox style={{ transform: "scale(1.5)" }} onChange={(e) => { updateNewAccess(e.target.checked, record.path, "visibility") }} checked={visibility === 1} disabled={!record.isParentEnabled} />
            },
        },
        {
            title: 'Read',
            dataIndex: 'read',
            render: (read, record) => {
                if (read !== null) {
                    return <Checkbox style={{ transform: "scale(1.5)" }} onChange={(e) => { updateNewAccess(e.target.checked, record.path, "read") }} checked={read === 1} disabled={!record.isParentEnabled} />
                }
            },
        },
        {
            title: 'Write',
            dataIndex: 'write',
            render: (write, record) => {
                if (write !== null) {
                    return <Checkbox style={{ transform: "scale(1.5)" }} onChange={(e) => { updateNewAccess(e.target.checked, record.path, "write") }} checked={write === 1} disabled={!record.isParentEnabled} />
                }
            },
        },
    ];

    return (
        <>
            <div>
                <div className="d-flex flex-stack">
                    <h1 className="page-heading text-dark fw-bold fs-3 my-0">New Roles</h1>
                </div>
                <div>
                    {state === 1 ?
                        <>
                            <div className="form d-flex flex-column flex-lg-row">
                                <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                                    <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-n2">
                                        <li className="nav-item">
                                            <span className={`nav-link text-active-primary pb-4 cursor-pointer ${navtype === "General" && "active"}`} onClick={(e) => { setnavtype("General"); }}>General</span>
                                        </li>
                                        <li className="nav-item">
                                            <span className={`nav-link text-active-primary pb-4 cursor-pointer ${navtype === "Advance" && "active"}`} onClick={(e) => { setnavtype("Advance"); }}>Permissions</span>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        {
                                            navtype === "General" &&
                                            <div className={`tab-pane fade ${navtype === "General" && "show active"}`} role="tab-panel">
                                                <div className="d-flex flex-column gap-7 gap-lg-10">
                                                    <div className="card card-flush py-4">
                                                        <div className="card-header">
                                                            <div className="card-title">
                                                                <h2>General</h2>
                                                            </div>
                                                        </div>
                                                        <div className="card-body pt-0">
                                                            <div className="w-100">
                                                                <div className="row mb-5">
                                                                    <div className="col-md-12 fv-row">
                                                                        <label className="required fs-5 fw-bold mb-2">Role Name</label>
                                                                        <input type="text" className="form-control form-control-solid" value={Role_name} onChange={(event) => { setRole_name(event.target.value); }} />
                                                                    </div>
                                                                </div>
                                                                <div className="row mb-5">
                                                                    <div className="col-md-12 fv-row">
                                                                        <label className="fs-5 fw-bold mb-2">Description</label>
                                                                        <textarea type="email" className="form-control form-control-solid" value={Description} onChange={(event) => { setDescription(event.target.value); }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {
                                            navtype === "Advance" &&
                                            <div className={`tab-pane fade ${navtype === "Advance" && "show active"}`} role="tab-panel">
                                                <div className="d-flex flex-column gap-7 gap-lg-10">
                                                    <div className="card card-flush py-4">

                                                        <div className="card-header">
                                                            <div className="card-title">
                                                                <h2>Permissions</h2>
                                                            </div>
                                                        </div>
                                                        <div className="card-body pt-0">
                                                            <button className="btn btn-secondary rounded m-3 p-5 float-right" onClick={scrollToBottom} title="Scroll to Bottom">
                                                                <i className="las la-angle-double-down" style={{ fontSize: "32px" }}></i>
                                                            </button>

                                                            <div>
                                                                <Table
                                                                    columns={columns}
                                                                    dataSource={(() => {
                                                                        return newAccess.access.map(x => {
                                                                            return recursiveTree(x, [], true)
                                                                        })
                                                                    })()}
                                                                    pagination={false}
                                                                />
                                                            </div>

                                                            <button className="btn btn-secondary rounded m-3 p-5 float-right" onClick={scrollToTop} title="Scroll to Top">
                                                                <i className="las la-angle-double-up" style={{ fontSize: "32px" }}></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {
                                        navtype === "General" ?
                                            <div className="d-flex justify-content-end">
                                                <button type="button" onClick={() => { setnavtype("Advance"); scrollToTop(); }} className="btn btn-lg btn-primary me-3">
                                                    <span>Continue<i className="fa fa-arrow-right ms-3"></i></span>
                                                </button>
                                            </div>
                                            :
                                            <div className="d-flex flex-stack pt-15">
                                                <div className="mr-2">
                                                    <button type="button" onClick={() => { setnavtype("General"); scrollToTop(); }} className="btn btn-lg btn-primary me-3">
                                                        <i className="fa fa-arrow-left ms-3"></i>Back
                                                    </button>
                                                </div>
                                                <div className="d-flex justify-content-end">
                                                    <button data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} onClick={(e) => { addRole(e) }} className="btn btn-primary">
                                                        <span className="indicator-label">Save Changes</span>
                                                        <span className="indicator-progress">Please wait...
                                                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                                                    </button>
                                                </div>
                                            </div>
                                    }
                                </div>
                            </div>
                        </>
                        :
                        state === 2 ?
                            <PageLoader />
                            :
                            <PageError />
                    }
                </div>
            </div>
        </>
    );
}
export default Roles;